import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { Link } from "react-router-dom";
import ContactUsSideInput from "../SideInputs/ContactUsSideInput";

const DetailModalContactUs = ({ setShowModal, title, buttonName, text, setRecheck, reCheck,id ,data}) => {
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
        const deleteArticle = async () => {

        const dataUser = await axiosReq("Admins/DeleteArticle?articleId=" + id + "", "delete", {
    
        });
        console.log(dataUser)
        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            setRecheck(!reCheck)
            setShowModal(false)
            alert("موفقیت آمیز");

        }
        else {
            console.log()

            //setShowErrorModalStep1(true);
        }

    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[18px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="flex justify-center items-center w-full  mb-[43px]">
                        <div className="bg-white w-[600px] ml-[20px]  rounded-2xl p-[30px] flex flex-col items-center justify-start content-center md:my-2 e1440:w-[700px] e1440:ml-0 e1440:mt-[20px] e1440:md:w-[100%] ">
            <div className=""><div className="mb-[12px] w-[410px] c550:w-[340px] c550:xs:w-[290px]">
        <ContactUsSideInput
        ContactUs={true}
        //   onBlur={blurHandler}
         // name=
        //   onChange={changeHandler}
         value={data?.name}
        //   onInput={maxLengthCheck}
          maxLength={100}
          title={"نام  "}
          placeHolder={"نام  "} /></div></div>
          <div className=""><div className="mb-[12px] w-[410px] c550:w-[340px] c550:xs:w-[290px]">
        <ContactUsSideInput
        ContactUs={true}
        //   onBlur={blurHandler}
        value={data?.email}        //   onChange={changeHandler}
        //   value={allValues?.Tag}
        //   onInput={maxLengthCheck}
          maxLength={100}
          title={"ایمیل  "}
          placeHolder={"ایمیل  "} /></div></div>
          <div className=""><div className="mb-[12px] w-[410px] c550:w-[340px] c550:xs:w-[290px]">
        <ContactUsSideInput
        ContactUs={true}
        //   onBlur={blurHandler}
        value={data?.title}
        //   onChange={changeHandler}
        //   value={allValues?.Tag}
        //   onInput={maxLengthCheck}
          maxLength={100}
          title={"عنوان  "}
          placeHolder={"عنوان  "} /></div></div>
                  <div className="w-[410px] mb-[28px] c550:w-[340px] c550:xs:w-[290px]">
          <p className="text-[18px] font-IRANYekanBold text-mainColor2 mb-[6px]">متن</p>
          <textarea
            name="Descreption"
            // onChange={changeHandler}
            value={data?.text}
            // onInput={maxLengthCheck}
            maxLength={100}
            className="h-[140px] w-full focus:outline-lightGray border-[2px] border-borderGray text-[13px] font-IRANYekanNormal p-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="متن" />
        </div>
        
            </div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default DetailModalContactUs;